import { FooterComponent } from './themes/footer/footer.component';
import { HeaderComponent } from './themes/header/header.component';
import { Component, Inject, PLATFORM_ID, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { BrevoService } from '../app/_services/brevo.service';
import { LoaderComponent } from './themes/loader/loader.component';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet,LoaderComponent,HeaderComponent,FooterComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'circledPlus';
  readonly hideSiteChrome = signal(false);
  email_subscribe: string = '';

  constructor(private brevoService: BrevoService, private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document) {
    this.updateSiteChrome();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateSiteChrome();
      }

      if (event instanceof NavigationStart) {
        this.stopAllVideos();
      }


    });
  }
  private updateSiteChrome(): void {
    let route = this.router.routerState.snapshot.root;
    while (route.firstChild) route = route.firstChild;
    this.hideSiteChrome.set(route.data['hideSiteChrome'] === true);
  }

  stopAllVideos() {
    // Guard: only runs in browser, not SSR/Node.js
    if (!isPlatformBrowser(this.platformId)) return;

    const videos = this.document.querySelectorAll<HTMLVideoElement>('video');
    videos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.load();
    });
  }

  subscribe() {
    if (!this.email_subscribe) return;

    this.brevoService.addSubscriber(this.email_subscribe).subscribe({
      next: () => {
        alert('Your Email has been Subscribed successfully 🎉');
        this.email_subscribe = '';
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

}
